import { RouteProp, useRoute } from "@react-navigation/native";
import BaseCard, { BaseCardListItem } from "components/BaseCard";
import Button from "components/Button";
import EventBanner from "components/EventBanner";
import MainContainer from "components/MainContainer";
import ShareDialog from "components/ShareDialog";
import Spacer from "components/Spacer";
import { AccountTicketDetails } from "features/types";
import { useAccount } from "hooks/useAccount";
import { MyEventsStackParamList } from "navigation/types";
import i18n from "plugins/localization";
import React, { useEffect, useMemo, useState } from "react";
import { View } from "react-native";
import { isTicketReservedByGuestComponent } from "screens/EventDetail/helpers";
import { toEventDetail, toMyEvents } from "utils/navigationUtils";
import GuestsCarousel from "./components/GuestsCarousel";

const Guests = () => {
  const { account, accountEvents: events } = useAccount();
  const route = useRoute<RouteProp<MyEventsStackParamList, "Guests">>();
  const { groupCode } = route.params;
  const [accountEvent, setAccountEvent] = useState<AccountTicketDetails | null>(
    null,
  );
  const [inviteGuestsDialog, setInviteGuestsDialog] = useState(false);

  const guestTickets = useMemo(() => {
    if (accountEvent === null) {
      return [];
    }
    return accountEvent.groupCode.tickets.filter(
      (ticket) =>
        ticket.planPackageComponentType?.includes("GUEST") &&
        ticket.reservedByAccountId === account!.id,
    );
  }, [accountEvent]);

  const openInviteGuestDialog = () => setInviteGuestsDialog(true);

  const hasNoRemainingGuestPasses =
    accountEvent?.tickets.filter((ticket) =>
      isTicketReservedByGuestComponent(ticket),
    ).length === 0;

  useEffect(() => {
    function findEvent() {
      if (!events || events.length === 0) return;
      const accountEvent = events.find(
        (accountEvent) => accountEvent.groupCode.groupCode === groupCode,
      );
      if (accountEvent === undefined) {
        toMyEvents();
        return;
      }
      setAccountEvent(accountEvent);
    }

    findEvent();
  }, [events]);

  if (!accountEvent) return null;

  return (
    <MainContainer grayBackground goBackAction={() => toEventDetail(groupCode)}>
      <View style={{ padding: 15 }}>
        <EventBanner event={accountEvent.event} />
        <Spacer margin={10} />
        <GuestsCarousel
          guestTickets={guestTickets}
          event={accountEvent.event}
        />
        <Spacer margin={10} />
        <Button
          onPress={openInviteGuestDialog}
          disabled={hasNoRemainingGuestPasses}
        >
          {i18n.t("screens.Guests.inviteGuests").toUpperCase()}
        </Button>
        <Spacer margin={20} />
        {!hasNoRemainingGuestPasses && (
          <BaseCard title={i18n.t("screens.Guests.cardTitle")}>
            <BaseCardListItem
              title={i18n.t("screens.Guests.inviteGuests")}
              onPress={openInviteGuestDialog}
            ></BaseCardListItem>
          </BaseCard>
        )}
        {inviteGuestsDialog && (
          <ShareDialog
            title={i18n.t("screens.Guests.inviteGuests")}
            visible={inviteGuestsDialog}
            setVisible={setInviteGuestsDialog}
            accountEvent={accountEvent}
            path="claim_guest_passes"
            type="guest"
            ticketProvider={accountEvent.event.ticketProvider}
          />
        )}
      </View>
    </MainContainer>
  );
};

export default Guests;
